import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography, CircularProgress, Alert } from '@mui/material';
import { AppDispatch, RootState } from '../../store';
import { fetchGames, resetCatalogToAllGames } from '../../store/gamesSlice';
import { addToFavorites, removeFromFavorites } from '../../store/favoritesSlice';
import GameCard from '../../components/GameCard/GameCard';
import { Game } from '../../types/game';

const GamesList: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { catalogGames, status, error } = useSelector((state: RootState) => state.games);
  const favorites = useSelector((state: RootState) => state.favorites.items);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchGames());
    } else {
      dispatch(resetCatalogToAllGames());
    }
  }, [dispatch, status]);

  const handleFavoriteToggle = (game: Game) => {
    const isFavorite = favorites.some(fav => fav.id === game.id);
    if (isFavorite) {
      dispatch(removeFromFavorites(game.id));
    } else {
      dispatch(addToFavorites(game));
    }
  };

  const handleGameClick = (gameId: number) => {
    navigate(`/game/${gameId}`);
  };

  if (status === 'loading' && catalogGames.length === 0) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
        <CircularProgress />
      </div>
    );
  }

  if (status === 'failed') {
    return <Alert severity="error">Ошибка загрузки игр: {error}</Alert>;
  }

  return (
    <div>
      <Typography variant="h4" component="h1" gutterBottom>
        Каталог игр
      </Typography>
      <Typography variant="body1" paragraph color="textSecondary">
        Всего игр: {catalogGames.length}
      </Typography>
      
      <Grid container spacing={3}>
        {catalogGames.map((game) => (
          <Grid item xs={12} sm={6} md={4} key={game.id}>
            <GameCard
              game={game}
              isFavorite={favorites.some(fav => fav.id === game.id)}
              onFavoriteToggle={handleFavoriteToggle}
              onClick={() => handleGameClick(game.id)}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default GamesList;